import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import { Modal, Button, Form } from "react-bootstrap";
import { FaEdit, FaFileExcel, FaTrash } from "react-icons/fa";
import axios from "axios";
import Swal from "sweetalert2";
import "./course.css";

// const API_URL = "http://localhost:8000/course.php";
const API_URL = "https://crm.fazoacademy.in/php/course.php";



function Course({ onLogout }) {
  const [courses, setCourses] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [newCourse, setNewCourse] = useState("");
  const [newshortcourse, setNewshortcourse] = useState("");
  const [amount, setAmount] = useState("");
  const [editCourse, setEditCourse] = useState({ id: null, name: "", short_course_name: "", amount: "" });
  const [searchQuery, setSearchQuery] = useState("");
  const [deleteCourseId, setDeleteCourseId] = useState(null);

  // Pagination States
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Fetch Courses from API
  const fetchCourses = async () => {
    try {
      const response = await axios.get(API_URL);
      console.log("Raw API Response:", response.data);
      const jsonString = response.data.substring(response.data.indexOf("["));
      const parsedData = JSON.parse(jsonString);
      setCourses(Array.isArray(parsedData) ? parsedData : []);
    } catch (error) {
      console.error("Error fetching courses:", error);
      setCourses([]);
    }
  };

  useEffect(() => {
    fetchCourses();
    
  }, []);

  // Add Course

  const normalizeText = (text) => text.replace(/\s+/g, " ").trim().toLowerCase();

  const capitalizeWords = (text) =>
    text.replace(/\b\w/g, char => char.toUpperCase());




  const handleAddCourse = async () => {
    const trimmedCourse = capitalizeWords(newCourse.trim());
    const trimmedShortCourse = newshortcourse.trim().toUpperCase();
    const trimedamount = amount.trim();

    // Prevent empty or only-space inputs
    if (!trimmedCourse || !trimmedShortCourse || !trimedamount) {
      Swal.fire({
        icon: "warning",
        title: "Feild EMPTY",
        text: "Fill All the feild",
      });
      return;
    }


    // Check for duplicate courses (case-insensitive)
    // if (courses.some(course => 
    //     course.name.trim().toLowerCase() === trimmedCourse.toLowerCase() 

    // )) {
    //     Swal.fire({
    //         icon: "error",
    //         title: "Duplicate Course",
    //         text: "This course already exists!",
    //     });
    //     return;
    
    if (courses.some(course =>
      normalizeText(trimmedCourse).includes(normalizeText(course.name)) ||
      normalizeText(course.name).includes(normalizeText(trimmedCourse))
    )) {
      Swal.fire({
        icon: "error",
        title: "Duplicate Course",
        text: "A similar course already exists!",
      });
      return;
    }


    try {
      await axios.post(API_URL, { name: trimmedCourse, short_course_name: trimmedShortCourse, amount: trimedamount });

      fetchCourses();
      setNewCourse("");
      setNewshortcourse("");
      setAmount("");
      setShowModal(false);

      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Course added successfully!",
        showConfirmButton: false,
        timer: 2000,
      });
    } catch (error) {
      console.error("Error adding course:", error);
      Swal.fire({
        icon: "error",
        title: "Oops!",
        text: "Failed to add course.",
      });
    }
  };


  // Edit Course
  const handleEditCourse = async () => {
    if (editCourse.name.trim()) {
      // Ensure we exclude the current course being edited in the duplicate check
      if (courses.some(course => course.id !== editCourse.id &&
        course.name === editCourse.name &&
        course.short_course_name === editCourse.short_course_name &&
        course.amount === editCourse.amount)) {
        alert("This course already exists!");
        return;
      }

      try {
        await axios.put(`${API_URL}/${editCourse.id}`, editCourse); // Include course ID

        fetchCourses();
        setShowEditModal(false);
        Swal.fire({
          icon: "success",
          title: "Updated!",
          text: "Course updated successfully!",
          showConfirmButton: false,
          timer: 2000,
        });
      } catch (error) {
        console.error("Error updating course:", error);
        Swal.fire({ icon: "error", title: "Oops!", text: "Failed to update course." });
      }
    }
  };

  // Delete Course
  const handleDeleteCourse = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(`${API_URL}?id=${id}`); // Correct API Call
          fetchCourses(); // Refresh data after deletion

          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: "Course has been deleted successfully.",
            showConfirmButton: false,
            timer: 2000,
          });
        } catch (error) {
          console.error("Error deleting course:", error);
          Swal.fire({
            icon: "error",
            title: "Oops!",
            text: "Failed to delete course. Please try again.",
          });
        }
      }
    });
  };

  //search 
  const filteredCourses = courses.filter(course =>
    course.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    course.amount.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentCourses = filteredCourses.slice(indexOfFirstItem, indexOfLastItem);

  const handleExportToExcel = () => {
    window.open(`${API_URL}?export=excel`, "_blank");
  };



  return (
    <div className="course-container">
      <div className="navigation">
        <a href="#">Course</a> / <a href="#" onClick={onLogout}>Logout</a>
      </div>

      <div className="add-course">
        <button onClick={() => setShowModal(true)} className="add-btn">
          Add new Course +
        </button>
      </div>

      <div className="d-flex justify-content-between">


        {/* Items per page selection */}
        <Form.Select
          value={itemsPerPage}
          onChange={(e) => setItemsPerPage(Number(e.target.value))}
          className="pagination-select"
        >
          <option value="10">Show 10</option>
          <option value="20">Show 20</option>
          <option value="30">Show 30</option>
        </Form.Select>

        <div className="search-container">
          <Form.Control
            type="text"
            placeholder="Search Course"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search-input"
          />
        </div>

        <Button onClick={handleExportToExcel} className="excel-btn">
          <FaFileExcel className="excel-icon" /> Export to Excel
        </Button>

      </div>


      <Table striped bordered hover className="course-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Course Name</th>
            <th>Course Fees</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {
            currentCourses.length === 0 ? (
              <tr>
                <td colSpan="7" className="text-center text-danger">
                  No details found
                </td>
              </tr>
            ) : (currentCourses.map((course, index) => (
              <tr key={course.id}>
                <td>{indexOfFirstItem + index + 1}</td>
                <td>{course.name}</td>
                <td>{course.amount}</td>
                <td>
                  <FaEdit
                    className="edit-icon"
                    onClick={() => {
                      setEditCourse(course);
                      setShowEditModal(true);
                    }}
                  />
                  <FaTrash
                    className="delete-icon"
                    onClick={() => handleDeleteCourse(course.id)}
                  />
                </td>
              </tr>
            )))}
        </tbody>
      </Table>

      {/* Pagination Controls */}
      <div className="pagination-controls">
        <Button
          variant="secondary"
          onClick={() => setCurrentPage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Previous
        </Button>
        <span className="page-number">Page {currentPage}</span>
        <Button
          variant="secondary"
          onClick={() => setCurrentPage(currentPage + 1)}
          disabled={indexOfLastItem >= filteredCourses.length}
        >
          Next
        </Button>
      </div>

      {/* Modals */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Course</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <Form.Control
            type="text"
            value={newCourse}
            onChange={(e) => {
              const value = e.target.value;
              if (/^[a-zA-Z0-9./ ]*$/.test(value)) {
                setNewCourse(value);
              }
            }}
            placeholder="Enter course name"
          /> */}
          <Form.Control
            type="text"
            value={newCourse}
            onChange={(e) => {
              const value = e.target.value;
              if (/^[a-zA-Z0-9./ ]*$/.test(value)) {
                setNewCourse(value);
                const shortValue = value.replace(/[^a-zA-Z]/g, '').substring(0, 2);
                setNewshortcourse(shortValue.toUpperCase()); // Optional: to make it uppercase
              }
            }}
            placeholder="Enter course name"
          />


          <br></br>
          <Form.Control
            type="text"
            value={amount}
            onChange={(e) => {
              const value = e.target.value;
              if (/^[0-9]{0,6}$/.test(value)) {
                setAmount(value);
              }
            }}
            placeholder="Enter course Amount"
          />

          <br></br>
          <Form.Control
            type="text"
            value={newshortcourse}
            onChange={(e) => {
              const value = e.target.value;
              if (/^[a-zA-Z]*$/.test(value)) {
                setNewshortcourse(value);
              }
            }}
            placeholder="Enter ShortCourse name"
            readOnly
          />
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="success" onClick={handleAddCourse}>
            Add Course
          </Button>
        </Modal.Footer>
      </Modal>

      
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Course</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Control
            type="text"
            value={editCourse.name}
            onChange={(e) => setEditCourse({ ...editCourse, name: e.target.value })}
          /><br></br>
          
          <Form.Control
            type="text"
            value={editCourse.amount}
            onChange={(e) => {
              const value = e.target.value;
              if (/^[0-9]{0,6}$/.test(value)) {
                setEditCourse({ ...editCourse, amount: value });
              }
            }}
            placeholder="Enter course amount"
          />
          <br></br>
          <Form.Control type="hidden"
         
            value={editCourse.short_course_name}
            onChange={(e) => setEditCourse({ ...editCourse, short_course_name: e.target.value })}
          />

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleEditCourse}>
            Update Course
          </Button>
        </Modal.Footer>
      </Modal>
    </div >
  );
}

export default Course;
